/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
/* Package JSON Import will be here */

/* Project Import will be here */
import TimeCardIssueComponent from './timeCardIssue.Component';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class TimeCardIssue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            issueNotes: [],
            isModalVisible: true,
            selectedDate: this.props.isCheckedArchive ? this.props.maximumDate : new Date(),
            searchIssueText: "",
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            isAttachmentModelVisible: false,
            selectedAttachment: "",
            minimumDate: this.props.minimumDate ? this.props.minimumDate : null,
            maximumDate: this.props.maximumDate ? this.props.maximumDate : new Date()
        };
         this.issueAbortController = null;
    }

    componentWillMount() {
        let { selectedDate } = this.state;
        if (this.props.isCheckedArchive) {
            selectedDate = this.props.maximumDate;
        }
        this.setState({ isModalVisible: true, selectedDate });
        this.getIssueNotes();
    }

    componentWillUnmount() {
        if(this.issueAbortController){
            this.issueAbortController.abort();
        }
    }

     getIssueNotes(date = null) {
        let { pagination } = this.state;
        
         if (this.issueAbortController) {
             this.issueAbortController.abort();
         }
         this.issueAbortController = new AbortController();
        //var dateSelected = date != null ? moment(new Date(date).toDateString()).format("DD-MMM-YY") : moment(new Date(this.state.selectedDate).toDateString()).format("DD-MMM-YY");

        var datePicked = date != null ? new Date(date) : new Date(this.state.selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = date == null ? new Date(this.state.selectedDate) : new Date(date);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format('DD-MM-YYYY');
        var selectedDate = moment(dateEndTime).format('DD-MM-YYYY');
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;

        var searchText = this.state.searchIssueText;
        let searchArray = [];
        if (searchText) {
            let searchObj = {
                FieldName: Constants.ISSUE_NOTES,
                Value: searchText
            };
            searchArray.push(searchObj);
        };
        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_Isu_Nte_M}?fromDate=${fromDate}&&toDate=${toDate}&&isCheckedArchive=${this.props.isCheckedArchive}`;
         Api.Post(url, requestData, this, this.issueAbortController?.signal).then(responseData => {
            if (responseData.success) {
                pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                this.setState({
                    issueNotes: responseData.data,
                    pagination
                });
            }
        });
    }

    closeModal() {
        this.setState({
            isModalVisible: false
        });
        this.props.closeIssue(true)
    }

    openModal() {
        this.setState({
            isModalVisible: true,
        });
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    handleDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            this.setState({
                selectedDate: date
            });
            this.getIssueNotes(date);
        }
        else {
            this.setState({
                issueNotes: []
            });
        }
    }

    paginationChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getIssueNotes();
        });
    }

    onIssueSearch = event => {
        this.setState({ searchIssueText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getIssueNotes();
        });
    }

    render() {
        const { issueNotes, isModalVisible, selectedDate, pagination, selectedAttachment, isAttachmentModelVisible, minimumDate, maximumDate } = this.state;
        return (
            <Fragment>
                <TimeCardIssueComponent
                    {...{
                        timeCardIssue: {
                            issueNotes,
                            isModalVisible,
                            selectedDate,
                            pagination,
                            selectedAttachment,
                            isAttachmentModelVisible,
                            minimumDate,
                            maximumDate,
                        }
                    }}
                    closeModal={this.closeModal.bind(this)}
                    openModal={this.openModal.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    paginationChange={this.paginationChange.bind(this)}
                    onIssueSearch={this.onIssueSearch.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

export default withRouter(connect(mapStateToProps)(TimeCardIssue));

TimeCardIssue.displayName = 'TimeCardIssue';